import angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import { LiveMapPopupComponent } from './live-map-popup.component';

export default angular
    .module('control-room.experience-promoter.live-map.live-map-popup', [])
    .directive('crLiveMapPopup', downgradeComponent({ component: LiveMapPopupComponent }));
